/* unplugin-vue-components disabled */import { render } from "./MyLink.vue?vue&type=template&id=69a0d2a6"
import script from "./MyLink.vue?vue&type=script&lang=js"
export * from "./MyLink.vue?vue&type=script&lang=js"

import "./MyLink.vue?vue&type=style&index=0&id=69a0d2a6&lang=css"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__